module.exports = __webpack_public_path__ + "img/stena15.5db88646.jpg";